<template lang="pug">
    div.modal-multiselect.is-scrollable
        ul
            li.single-line-taxo(v-for="item, key in itemsListPopulated" :key="key")
                //- div.taxonomy-sharing-info-hidden(:for="item.id")
                div.single-line-taxo_top.l-flex-row.l-align-center
                    input.taxo-sharing-checkbox(
                        type="checkbox"
                        :id="item.id"
                        :value="item.id"
                        v-model="activeItems"
                        @change="updateList(item.id, item.sharingName, getSharedTaxonomyId(item.id))"
                    )
                    label.taxonomy-sharing-info.flex-1(:for="item.id")
                        div.taxonomy-sharing-id(v-if="item.id") {{item.id}}
                        div.taxonomy-sharing-label(v-if="item.label") {{item.label}}

                div.single-line-taxo_btm
                    div.partner-taxo-label.info-block(:class="{'ui-disabled': !partnerLabelEditable(item.id)}")
                        div.label Visible label
                        div.item-value
                            input.partner-taxo-label-input(
                                type="text"
                                :name="'current taxonomy label ' + item.id"
                                v-model="item.sharingName"
                                :class="{'edit-single-input': partnerLabelEditable(item.id)}"
                                placeholder="Select your sharing label"
                                @change="saveNewSharingLabel(item.id, $event.target.value, getSharedTaxonomyId(item.id))"
                                @blur="handleResetFieldOnLeave(item.id)"
                                v-validate="'required|min:1|max:200|allowed_characters'"
                            )
                            span.form-validate-error {{ errors.first('current taxonomy label ' + item.id) }}


</template>
<script>
import { find, findIndex } from 'lodash'
import { Validator } from 'vee-validate'

export default {
    name: 'MultiSelect',
    props: {
        itemsList: { type: Array, required: true },
        previouslyActive: { type: Array, required: true },
        selectedTaxo: { type: Object, required: true },
        currentTaxonomyItemsList: { type: Array, required: false, default: () => [] }
    },

    data() {
        return {
            activeItems: [],
            itemsListPopulated: []
        }
    },

    watch: {
        previouslyActive: {
            handler: function(val) {
                this.activeItems = val
            }
        },
        selectedTaxo: {
            handler: function() {
                this.populateItemsListWithSharingLabel()
            }
        },
        currentTaxonomyItemsList: {
            handler: function() {
                this.populateItemsListWithSharingLabel()
            }
        }
    },

    mounted() {
        this.activeItems = this.previouslyActive
        this.populateItemsListWithSharingLabel()

        Validator.extend('allowed_characters', {
            getMessage: () => 'Please use only letters, numbers, spaces, dashes or underscores',
            validate: value => RegExp('^[-_ a-zA-Z0-9]*$').test(value)
        })

        const dictionary = {
            en: {
                messages: {
                    required: 'The taxonomy label field is required'
                }
            }
        }
        Validator.localize(dictionary)
    },

    methods: {
        partnerLabelEditable(id) {
            return this.activeItems.includes(id.toString())
        },
        updateList(accontId, sharingName, taxoId) {
            this.$emit('listChanged', this.activeItems)
            if (sharingName !== this.selectedTaxo.label) this.saveNewSharingLabel(accontId, sharingName, taxoId)
        },

        /**
         * Returns the label that has been used when it was shared with an other account
         * @param {String | Number} accountId id of the taxonomy
         * @returns {String}
         */
        getSharedTaxonomyLabel(accountId) {
            const taxo = find(this.currentTaxonomyItemsList, item => item.product_account_id === accountId)
            // Only taxo that has already been shared will retrieve their labels
            if (taxo) return taxo.label
            return this.selectedTaxo.label
        },

        /**
         * Returns the id of the taxonomy
         * @param {String | Number} accountId id of the taxonomy
         * @returns {String}
         */
        getSharedTaxonomyId(accountId) {
            const taxo = find(this.currentTaxonomyItemsList, item => item.product_account_id === accountId)

            // Only taxo that has already been shared will retrieve their ids
            if (taxo) return taxo.id
        },
        saveNewSharingLabel(accountId, event, taxoId) {
            if (event !== '') this.$emit('labelUpdated', accountId, event, taxoId)
        },
        populateItemsListWithSharingLabel() {
            this.itemsListPopulated = this.itemsList.map(item => ({ ...item, sharingName: this.getSharedTaxonomyLabel(item.id) }))
        },
        handleResetFieldOnLeave(id) {
            const index = findIndex(this.itemsListPopulated, item => item.id === id)
            if (this.errors.first('current taxonomy label ' + id)) {
                this.itemsListPopulated[index].sharingName = this.getSharedTaxonomyLabel(id)
                this.errors.clear()
            }
        }
    }
}
</script>
